import {SiteResponse} from '../interfaces/Site';

const testRetailSites: SiteResponse[] = [
  {
    SiteId: 'NNRTST1',
    SiteName: 'Nike NA Retail Test 1',
    Brand: 'Nike',
    Geo: 'NA',
    Address: {
      $type: 'siteAddressItem',
      address1: '3800 Colonnade Pkwy.',
      address2: 'Suite 575',
      address3: '',
      area: '',
      city: 'Birmingham',
      state: 'AL',
      postalCode: '35243',
      country: 'USA',
      iso2Country: 'US',
      county: '',
    },
    SiteType: 'Retail',
    BusinessStatus: 'Open',
    StoreConcept: 'Retail',
    HasNpos: true,
    isTestSite: true,
  },
];

export default [...testRetailSites];
